import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { RequestInProgressService }  from '@trivelope/triv-ui-tools-lib';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DataInput }  from '@trivelope/triv-ui-tools-lib';
import { ReportingYear } from 'src/app/classes/reportingData';
import { YearService } from 'src/app/services/year.service';
import { InfoDialogComponent }  from '@trivelope/triv-ui-tools-lib';
import { MatDialog } from '@angular/material/dialog';
import { Environment } from 'src/app/classes/environment';


@Component({
	selector: 'app-year-editor',
	templateUrl: './year-editor.component.html',
	styleUrls: ['./editor.component.css']
})
export class YearEditorComponent implements OnInit {


	private _element: ReportingYear = new ReportingYear();
	@Input() set element( val: ReportingYear ) {
		this._element = val;
		this.updateValueForm();
	}
	get element() {
		return this._element;
	}
	formG1: UntypedFormGroup = this._fb.group({});
	myInputs: { [name: string]: DataInput } = {};

	@Output() done = new EventEmitter<ReportingYear>();

	@Input() bCreation = false;
	dateError = "";

	constructor(
		@Inject(RequestInProgressService) public requestInProgressService: RequestInProgressService,
		private _fb: UntypedFormBuilder,
		private yearService: YearService,
		private matDialog: MatDialog,
		@Inject('environment') private environment: Environment,
	) {}

	async ngOnInit() {
		console.log( 'YEAR-EDITOR.component ngOnInit()')

		for( let dataInput of this.environment.year ) {

			this.myInputs[ dataInput.id ] = dataInput;
		}
		setTimeout( () => {
			this.updateValueForm();
		}, 1)

	}

	showInfoFreigabe() {
		this.matDialog.open( InfoDialogComponent, {
			data: "Durch die Freigabe wird das Berichtsjahr in der Datenpflege sichtbar. Eine Freigabe solle erst erfolgen, wenn genügend Daten gemeldet werden."
		});
	}

	updateValueForm() {

		if( !this.formG1.get( 'bjJahr' ) ) return;
		// the formgroup is not initialized => return

		this.formG1.reset();

		const valuesToPatch = new ReportingYear();
		for( const property in this._element ) {
			if( !this._element.hasOwnProperty(property) ) continue;
			if( property == "bjVon" ) continue;
			if( property == "bjBis" ) continue;
			valuesToPatch[ property ] = this._element[ property ];
		}

		const o = valuesToPatch as any;
		delete o[ "bjVon" ];
		delete o[ "bjBis" ];
		this.formG1.patchValue( o );

		const tms1 = this._element.bjVon;
		if( tms1 ) {
			const dt = new Date();
			dt.setTime( tms1 );
			// formatDate( tms1, "yyyy-MM-dd", "de-DE" );
			if( dt ) {
				const str = dt.toISOString().slice( 0, 10 );
				this.formG1.get( "bjVon" )?.patchValue( str );
			}
		}
		const tms2 = this._element.bjBis;
		if( tms2 ) {
			const dt = new Date();
			dt.setTime( tms2 );
			if( dt ) {
				const str = dt.toISOString().slice( 0, 10 );
				this.formG1.get( "bjBis" )?.patchValue( str );
			}
		}


		if( this._element.bjJahr ) {
			this.formG1.get( "bjJahr" )?.disable();
		}

	}

	cancel() {
		this.done.emit( new ReportingYear() );
	}

	reset() {
		this.dateError = '';
		this.updateValueForm();
	}

	save() {
		const f = this.formG1.value;

		const strDt1 = f[ 'bjVon' ];
		if( !strDt1 ) {
			this.dateError = "ungültiges Datum";
			return;
		}
		const dt1 = new Date( strDt1 );
		if( !dt1 ) {
			this.dateError = "ungültiges Datum";
			return;
		}
		const strDt2 = f[ 'bjBis' ];
		if( !strDt2 ) {
			this.dateError = "ungültiges Datum";
			return;
		}
		const dt2 = new Date( strDt2 );
		if( !dt2 ) {
			this.dateError = "ungültiges Datum";
			return;
		}
		if( dt2.getTime() <= dt1.getTime() ) {
			this.dateError = "Das Startdatum muss vor dem Enddatum liegen";
			return;
		}
		this.dateError = "";

		const elementToSave: ReportingYear = { ...this._element };

		for( const field in this.myInputs ) {

			if( this._element.bjJahr && (field == "bjJahr") ) continue;

			let value = f[ field ];

			if( this.myInputs[ field ].type == "date" ) {
				const dt = new Date( value );
				if( dt ) value = dt.getTime();
			}

			(elementToSave[ field as keyof ReportingYear ] as any) = value;
		}



		if( !this._element.bjJahr ) {
			this.yearService.create( elementToSave ).subscribe( elementSaved => {
				if( elementSaved && elementSaved.bjJahr ) {
					this._element = elementSaved;
					this.done.emit(elementSaved);
				}
			});
		}
		else {
			this.yearService.update( elementToSave ).subscribe( b => {
				if( b ) {
					for( const field in elementToSave ) {
						this._element[ field ] = elementToSave[ field ] ;
					}
					this.done.emit( this._element );
					this.formG1.markAsPristine();
				}
			});
		}


	}
}
